import { render, staticRenderFns } from "./SubmissionTitle.vue?vue&type=template&id=25909af8&"
import script from "./SubmissionTitle.vue?vue&type=script&lang=js&"
export * from "./SubmissionTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports